import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-category" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "root-bar" }
const _hoisted_4 = { class: "search-bar-extra" }
const _hoisted_5 = ["onClick"]

import { useRouter, useRoute } from 'vue-router'
import { watch } from 'vue'
import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCategory',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const columns = [
  { title: '产品品类名称', dataIndex: 'name', key: 'name' },
  { title: '产品品类描述', dataIndex: 'desc', key: 'desc' },
  { title: '图片', dataIndex: 'image', key: 'image' },
  { title: '操作', key: 'action' }
]
const dataSource = [
  { id: 1, name: '传感器设备', desc: '', image: '' },
  { id: 2, name: '照明设备', desc: '', image: '' },
  { id: 3, name: '空调设备', desc: '', image: '' },
  { id: 4, name: '风扇设备', desc: '', image: '' }
]

const handleAdd = () => {
  router.push('/network/device-mgr')
}

function onSelectSideMenu(keys: string[]) {
  if (keys[0] === 'device-mgr') router.push('/network/device-mgr')
  else if (keys[0] === 'product-mgr') router.push('/network/product-mgr')
  // ...其它菜单
}

const topKeyMap = [
  { key: 'dashboard', path: '/' },
  { key: 'network', path: '/network/overview' },
  { key: 'system', path: '/system' },
  { key: 'lowcode', path: '/lowcode' },
  { key: 'profile', path: '/profile' }
]

const selectedTopKeys = ref(['dashboard'])

watch(
  () => route.path,
  (path) => {
    if (path === '/' || path === '') selectedTopKeys.value = ['dashboard']
    else if (path.startsWith('/network')) selectedTopKeys.value = ['network']
    else if (path.startsWith('/system')) selectedTopKeys.value = ['system']
    else if (path.startsWith('/lowcode')) selectedTopKeys.value = ['lowcode']
    else if (path.startsWith('/profile')) selectedTopKeys.value = ['profile']
    else selectedTopKeys.value = ['dashboard']
  },
  { immediate: true }
)

function onTopMenuClick({ key }: { key: string }) {
  if (key === 'dashboard') router.push('/')
  else if (key === 'network') router.push('/network/overview')
  else if (key === 'system') router.push('/system')
  else if (key === 'lowcode') router.push('/lowcode')
  else if (key === 'profile') router.push('/profile')
}

const selectedSideKeys = ref(['overview'])
const openKeys = ref(['access', 'ops'])

watch(
  () => route.path,
  (path) => {
    // 侧边栏高亮
    if (path === '/network/overview') selectedSideKeys.value = ['overview']
    else if (path === '/network/device-mgr') {
      selectedSideKeys.value = ['device-mgr']
      openKeys.value = ['access']
    }
    else if (path === '/network/model') {
      selectedSideKeys.value = ['model']
      openKeys.value = ['access']
    }
    else if (path === '/network/product-mgr') {
      selectedSideKeys.value = ['product-mgr']
      openKeys.value = ['access']
    }
    else if (path === '/network/product-cat') {
      selectedSideKeys.value = ['product-cat']
      openKeys.value = ['access']
    }
    else if (path === '/network/ota') {
      selectedSideKeys.value = ['ota']
      openKeys.value = ['ops']
    }
    // ...其它菜单
  },
  { immediate: true }
)

function goDetail(record: any) {
  router.push(`/network/product-cat/${record.id}`)
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "产品品类名称",
                        labelCol: { flex: '100px' },
                        wrapperCol: { flex: 'auto' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            placeholder: "请输入产品品类名称",
                            style: {"width":"100%"}
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            style: {"margin-right":"8px"}
                          }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                              _createTextVNode("查询")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_a_button, null, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode("重置")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "root-tip" }, "根节点：全部产品品类", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, { type: "link" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("新增")
                ])),
                _: 1
              }),
              _createVNode(_component_a_button, { type: "link" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("物模型")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(_component_a_table, {
          columns: columns,
          "data-source": dataSource,
          pagination: false,
          rowKey: "id"
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  width: 48,
                  height: 48,
                  preview: false,
                  src: "https://img.icons8.com/ios/100/000000/image.png"
                }))
              : (column.key === 'action')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[5] || (_cache[5] = _createElementVNode("a", {
                      onClick: () => {},
                      style: {"color":"#1677ff","margin-right":"8px"}
                    }, "新增", -1)),
                    _createElementVNode("a", {
                      onClick: () => goDetail(record),
                      style: {"color":"#1677ff","margin-right":"8px"}
                    }, "详情", 8, _hoisted_5),
                    _cache[6] || (_cache[6] = _createElementVNode("a", {
                      onClick: () => {},
                      style: {"color":"#ff4d4f"}
                    }, "删除", -1))
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})